// Default homepage — fully editable blocks (sections -> rows -> columns -> blocks),
// styled with the production palette. Stored/edited in Firestore `pages/home`.
export const DEFAULT_NAV = [
  { id: 'home', label: '首页', visible: true },
  { id: 'about', label: '关于', visible: true },
  { id: 'modern', label: '总则', visible: true },
  { id: 'career', label: '职业生涯', visible: true },
  { id: 'contact', label: '联络', visible: true },
];

export const DEFAULT_PAGE = [
  {
    id: 'home', title: '', icon: '', bg: '#e4dbd2', bgImage: 'asset:homebg', bgOpacity: 0.15, pad: '60px 10px',
    rows: [
      {
        id: 'home-r1',
        columns: [
          { id: 'home-c1', span: 5, blocks: [{ id: 'home-b1', type: 'image', url: 'asset:home_main', alt: 'Company' }] },
          {
            id: 'home-c2', span: 7, align: 'right',
            blocks: [
              { id: 'home-b2', type: 'heading', level: 'h1', text: '新焦点中医培训学校', align: 'right', color: '#240F3A' },
              { id: 'home-b3', type: 'heading', level: 'h1', text: 'New Axis Training Centre', align: 'right', color: '#240F3A' },
              { id: 'home-b4', type: 'text', text: 'of Traditional Chinese Medical', align: 'right', color: '#240F3A', size: '30px' },
              { id: 'home-b5', type: 'button', text: '立即开始', link: '#about', align: 'right', bg: '#AF9792', color: '#ffffff', size: '27px' },
            ],
          },
        ],
      },
      {
        id: 'home-r2',
        columns: [
          {
            id: 'home-c3', span: 12, bg: '#AF9792', pad: '20px 30px', radius: '10px', align: 'center',
            blocks: [
              { id: 'home-b6', type: 'image', url: 'asset:code', alt: 'QR', width: '90px', height: '90px' },
              { id: 'home-b7', type: 'text', text: '探索更多精彩内容，立即扫码！', align: 'center', color: '#ffffff', size: '22px' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'about', title: '关于', icon: 'asset:info',
    rows: [
      {
        id: 'about-r1',
        columns: [
          {
            id: 'about-c1', span: 4, bg: '#F5F1E8', pad: '30px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b1', type: 'image', url: 'asset:aim', alt: 'Aim', width: '60px' },
              { id: 'about-b2', type: 'heading', level: 'h4', text: '校训', align: 'center', color: '#443518' },
              { id: 'about-b3', type: 'text', text: '勤求博采', align: 'center', color: '#3A1515' },
              { id: 'about-b4', type: 'text', text: '厚德济世', align: 'center', color: '#3A1515' },
            ],
          },
          {
            id: 'about-c2', span: 4, bg: '#F5F1E8', pad: '30px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b5', type: 'image', url: 'asset:idea', alt: 'Idea', width: '60px' },
              { id: 'about-b6', type: 'heading', level: 'h4', text: '办学理念', align: 'center', color: '#443518' },
              { id: 'about-b7', type: 'text', text: '勤学苦练', align: 'center', color: '#3A1515' },
              { id: 'about-b8', type: 'text', text: '传承创新', align: 'center', color: '#3A1515' },
            ],
          },
          {
            id: 'about-c3', span: 4, bg: '#F5F1E8', pad: '30px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b9', type: 'image', url: 'asset:training', alt: 'Training', width: '60px' },
              { id: 'about-b10', type: 'heading', level: 'h4', text: '宗旨', align: 'center', color: '#443518' },
              { id: 'about-b11', type: 'text', text: '医者仁心', align: 'center', color: '#3A1515' },
              { id: 'about-b12', type: 'text', text: '全人健康', align: 'center', color: '#3A1515' },
            ],
          },
        ],
      },
      {
        id: 'about-r2',
        columns: [
          {
            id: 'about-c4', span: 12, bg: '#4a391e', pad: '35px', radius: '5px',
            blocks: [
              { id: 'about-b13', type: 'heading', level: 'h2', text: 'New Axis Training Centre', align: 'left', color: '#FEFEFF' },
              { id: 'about-b14', type: 'heading', level: 'h1', text: '团队建设', align: 'right', color: '#FEFEFF' },
            ],
          },
        ],
      },
      {
        id: 'about-r3',
        columns: [
          {
            id: 'about-c5', span: 3, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b15', type: 'image', url: 'asset:su', alt: 'SuYouRen', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b16', type: 'text', text: '首席执行官-苏幼仁', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b17', type: 'text', text: '马来西亚城市大学本科学院院长 博士', align: 'center' },
            ],
          },
          {
            id: 'about-c6', span: 3, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b18', type: 'image', url: 'asset:hu', alt: 'HuTao', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b19', type: 'text', text: '董事长-胡涛', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b20', type: 'text', text: '上海侨成教育科技有限公司', align: 'center' },
            ],
          },
          {
            id: 'about-c7', span: 3, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b21', type: 'image', url: 'asset:jin', alt: 'JinMeiHua', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b22', type: 'text', text: '校长-金美花', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b23', type: 'text', text: '毕业于北京中医药大学 硕士\n先后在西苑医院及北京中医药大学从事医疗教学工作三十余年', align: 'center' },
            ],
          },
          {
            id: 'about-c8', span: 3, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b24', type: 'image', url: 'asset:feng', alt: 'FengQiuJu', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b25', type: 'text', text: '教学主管 - 冯秋菊', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b26', type: 'text', text: '毕业于北京中医药大学\n师承于首届国医大师贺普仁教授\n北京针灸三通法常务理事\n中推（北京）联合研究院学术委员会副主任', align: 'center' },
            ],
          },
        ],
      },
      {
        id: 'about-r4',
        columns: [
          {
            id: 'about-c9', span: 4, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b27', type: 'image', url: 'asset:yang', alt: 'YangYiXi', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b28', type: 'text', text: '教务主管 - 杨忆熙', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b29', type: 'text', text: '本科毕业于北京中医药大学\n中国中医科学院在职研究生 硕士\n曾在中国中医科学院广安门医院急诊科从事临床及教学工作二十年', align: 'center' },
            ],
          },
          {
            id: 'about-c10', span: 4, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b30', type: 'image', url: 'asset:zhou', alt: 'ZhouZhongBin', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b31', type: 'text', text: '总务主管 - 周忠斌', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b32', type: 'text', text: '毕业于东北师范大学 硕士\n马来西亚城市大学 博士\n长春师范大学讲师\n柏辰艺术高中教学校长\n清华大学建筑设计研究院二分院 顾问', align: 'center' },
            ],
          },
          {
            id: 'about-c11', span: 4, bg: '#ffffff', pad: '20px 10px', radius: '5px', shadow: true, align: 'center',
            blocks: [
              { id: 'about-b33', type: 'image', url: 'asset:hui', alt: 'HuiJingBo', shape: 'circle', width: '80px', height: '80px' },
              { id: 'about-b34', type: 'text', text: '外事兼财务主管 - 惠婧博', align: 'center', color: '#443518', size: '18px' },
              { id: 'about-b35', type: 'text', text: '毕业于东北师范大学 硕士', align: 'center' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'modern', title: '总则', icon: 'asset:modernization', bg: '#F5F1E8', pad: '60px 20px',
    rows: [
      {
        id: 'modern-r1',
        columns: [
          {
            id: 'modern-c1', span: 6,
            blocks: [
              { id: 'modern-b1', type: 'image', url: 'asset:img1', alt: 'Modern', radius: '10px' },
              { id: 'modern-b2', type: 'image', url: 'asset:img2', alt: 'Modern', radius: '10px' },
            ],
          },
          {
            id: 'modern-c2', span: 6,
            blocks: [
              { id: 'modern-b3', type: 'heading', level: 'h3', text: '总则', align: 'left', color: '#131D49' },
              { id: 'modern-b4', type: 'text', text: 'New Axis Training Centre教育不仅旨在开发学生的学术和智力潜力。道德和品格建设目标是课程中非常重要的一部分。事实上，教育的主要关注点是将人格视为一个完整的整体，包括身体、情感、智力、精神和社会方面。', align: 'left', color: '#4C4B4B' },
              { id: 'modern-b5', type: 'text', text: '为了履行其使命和目标，学校通过实施精心设计的课程，努力确保教学质量，并将持续监控和严格评估所有相关活动和系统，以确保教学水平。', align: 'left', color: '#4C4B4B' },
              { id: 'modern-b6', type: 'heading', level: 'h3', text: '着重于学生的', align: 'center', color: '#000000' },
              { id: 'modern-b7', type: 'heading', level: 'h2', text: '职业与就业规划', align: 'center', bg: '#443518', color: '#ffffff', pad: '20px', radius: '20px' },
            ],
          },
        ],
      },
      {
        id: 'modern-r2',
        columns: [
          {
            id: 'modern-c3', span: 12, align: 'center',
            blocks: [
              { id: 'modern-b8', type: 'image', url: 'asset:high_five', alt: 'Collaborate', width: '60px', height: '60px' },
              { id: 'modern-b9', type: 'text', text: '鼓励学生积极参与学习过程，并通过实践、协作和探索来积累知识和技能。', align: 'center', color: '#000000' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'career', title: '职业生涯', icon: 'asset:career',
    rows: [
      {
        id: 'career-r1',
        columns: [
          {
            id: 'career-c1', span: 12,
            blocks: [
              { id: 'career-b1', type: 'heading', level: 'h3', text: '职业生涯', align: 'left', color: '#131D49' },
              { id: 'career-b2', type: 'heading', level: 'h2', text: '毕业证含金量, 4大机构认证', align: 'center', color: '#000000' },
              { id: 'career-b3', type: 'text', text: '—— 拥有绝对的就业及升学优势！', align: 'right', color: '#4C4B4B' },
            ],
          },
        ],
      },
      {
        id: 'career-r2',
        columns: [
          {
            id: 'career-c2', span: 6, bg: '#F5F1E8', pad: '30px 10px', radius: '20px', shadow: true, align: 'center',
            blocks: [
              { id: 'career-b4', type: 'image', url: 'asset:mcma', alt: 'MCMA', align: 'center', width: '70%', fit: 'contain' },
              { id: 'career-b5', type: 'text', text: '马来西亚中医总会', align: 'center', size: '20px' },
              { id: 'career-b6', type: 'text', text: 'Malaysia Chinese Medical Association', align: 'center' },
            ],
          },
          {
            id: 'career-c3', span: 6, bg: '#F5F1E8', pad: '30px 10px', radius: '20px', shadow: true, align: 'center',
            blocks: [
              { id: 'career-b7', type: 'image', url: 'asset:mlvk', alt: 'MLVK', align: 'center', width: '70%', fit: 'contain' },
              { id: 'career-b8', type: 'text', text: '大马技术学术局', align: 'center', size: '20px' },
              { id: 'career-b9', type: 'text', text: 'National Vocational Training Council', align: 'center' },
            ],
          },
        ],
      },
      {
        id: 'career-r3',
        columns: [
          {
            id: 'career-c4', span: 6, bg: '#F5F1E8', pad: '30px 10px', radius: '20px', shadow: true, align: 'center',
            blocks: [
              { id: 'career-b10', type: 'image', url: 'asset:mly', alt: 'MLY', align: 'center', width: '70%', fit: 'contain' },
              { id: 'career-b11', type: 'text', text: '马来西亚政府', align: 'center', size: '20px' },
              { id: 'career-b12', type: 'text', text: 'Malaysia Government', align: 'center' },
            ],
          },
          {
            id: 'career-c5', span: 6, bg: '#F5F1E8', pad: '30px 10px', radius: '20px', shadow: true, align: 'center',
            blocks: [
              { id: 'career-b13', type: 'image', url: 'asset:mqa', alt: 'MQA', align: 'center', width: '70%', fit: 'contain' },
              { id: 'career-b14', type: 'text', text: '马来西亚学术资格鉴定机构', align: 'center', size: '20px' },
              { id: 'career-b15', type: 'text', text: 'Malaysian Qualifications Agency', align: 'center' },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 'contact', title: '联络', icon: 'asset:contact_mail', bg: '#F5F1E8',
    rows: [
      {
        id: 'contact-r1',
        columns: [
          {
            id: 'contact-c1', span: 4,
            blocks: [
              { id: 'contact-b1', type: 'image', url: 'asset:logo', alt: 'Logo' },
              { id: 'contact-b2', type: 'heading', level: 'h4', text: '连接我们', align: 'left' },
              { id: 'contact-b3', type: 'text', text: 'New Axis Training Centre', align: 'left' },
              { id: 'contact-b4', type: 'image', url: 'asset:instagram', alt: 'Instagram', width: '36px' },
              { id: 'contact-b5', type: 'image', url: 'asset:facebook', alt: 'Facebook', width: '36px' },
            ],
          },
          {
            id: 'contact-c2', span: 4,
            blocks: [
              { id: 'contact-b6', type: 'heading', level: 'h4', text: '找到我们', align: 'left' },
              { id: 'contact-b7', type: 'text', text: 'New Axis Training Centre', align: 'left' },
              { id: 'contact-b8', type: 'text', text: '30 Jalan Kelumpang, Pelabuhan Klang, Selangor.', align: 'left' },
            ],
          },
          {
            id: 'contact-c3', span: 4,
            blocks: [
              { id: 'contact-b9', type: 'heading', level: 'h4', text: '感兴趣?', align: 'left' },
              { id: 'contact-b10', type: 'text', text: '直接拨打 +601****2745', align: 'left' },
              { id: 'contact-b11', type: 'text', text: '发送邮件至 newaxistrainingcentre@gmail.com', align: 'left' },
              { id: 'contact-b12', type: 'text', text: '私信 Whatsapp +601****2745', align: 'left' },
            ],
          },
        ],
      },
    ],
  },
];
